module.exports = __webpack_public_path__ + "static/media/bdsports_cms.7f9f11e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/BlackDiamond/bdsports_cms.jpg
// module id = 646
// module chunks = 0